import {
    KHOPHIEU_COUNT_ASSIGN_SUCCESS,
    KHOPHIEU_HISTORY_LIST_SUCCESS,
    KHOPHIEU_IMPORT_SUCCESS,
    KHOPHIEU_LIST_SUCCESS,
    KHOPHIEU_NEW_CARE_SUCCESS,
    KHOPHIEU_ONE_SUCCESS,
    KHOPHIEU_UPDATE_FILTER,
  
    KHOPHIEU_UPDATE_HOMEPAGE_FILTER,
    KHOPHIEU_HOMEPAGE_LIST_SUCCESS,
    KHOPHIEU_HOMEPAGE_ONE_SUCCESS,
  
    KHOPHIEU_LIMIT_UPDATE_HOMEPAGE_FILTER,
    KHOPHIEU_LIMIT_HOMEPAGE_LIST_SUCCESS,
    KHOPHIEU_LIMIT_HOMEPAGE_ONE_SUCCESS,
  } from 'src/actions/khophieu.action';
  import { LOOKUP_CLEANER } from 'src/actions/lookup.action';
  
  import {
    DEFAULT_ROW_PER_PAGE,
  } from 'src/utils/constants';
  
  import dayjs from 'dayjs';
  
  const today = new Date();
  
  const initState = {
    filter: {
      message: '',
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
      endDate: dayjs(today),
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
    },
    homepageKhophieuFilter: {
      message: '',
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
      endDate: dayjs(today),
      homepageKhophieuPage: 0,
      homepageKhophieuLimit: DEFAULT_ROW_PER_PAGE,
    },
    homepageKhophieuLimitFilter: {
      message: '',
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
      endDate: dayjs(today),
      homepageKhophieuLimitPage: 0,
      homepageKhophieuLimitLimit: DEFAULT_ROW_PER_PAGE,
    },
    items: [],
    total: 0,
    selected: undefined,
  
    homepageKhophieuItems: [],
    homepageKhophieuTotal: 0,
    homepageKhophieuSelected: undefined,
  
    homepageKhophieuLimitItems: [],
    homepageKhophieuLimitTotal: 0,
    homepageKhophieuLimitSelected: undefined,
  
    temp: [],
    countAssign: 0,
    history: [],
    totalHistory: 0,
    newCare: undefined,
    canCare: 0,

    ton_hien_tai: 0,
    ton_dau_ky: 0,
    nhap_trong_ky: 0,
    xuat_trong_ky: 0,
    ton_cuoi_ky: 0,
  }
  
  const khophieuReducer = (state = initState, action) => {
    switch (action.type) {
      case KHOPHIEU_UPDATE_FILTER:  {
        if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
          if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
          if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
        }
        return {
          ...state,
          filter: action.data,
        }
      }
      case KHOPHIEU_LIST_SUCCESS: {
        return {
          ...state,
          items: action.data.items,
          total: action.data.total,
        }
      }
      case KHOPHIEU_ONE_SUCCESS: {
        return {
          ...state,
          selected: action.data
        }
      }
      case KHOPHIEU_UPDATE_HOMEPAGE_FILTER:  {
        if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageKhophieuFilter !== 'undefined' && state.homepageKhophieuFilter) {
          if (action.data.homepageKhophieuPage == 'no_update' && typeof state.homepageKhophieuFilter.homepageKhophieuPage !== 'undefined') action.data.homepageKhophieuPage = state.homepageKhophieuFilter.homepageKhophieuPage;
          if (action.data.homepageKhophieuLimit == 'no_update' && typeof state.homepageKhophieuFilter.homepageKhophieuLimit !== 'undefined') action.data.homepageKhophieuLimit = state.homepageKhophieuFilter.homepageKhophieuLimit;
        }
        return {
          ...state,
          homepageKhophieuFilter: action.data,
        }
      }
      case KHOPHIEU_HOMEPAGE_LIST_SUCCESS: {
        return {
          ...state,
          homepageKhophieuItems: action.data.homepageKhophieuItems,
          homepageKhophieuTotal: action.data.homepageKhophieuTotal,
        }
      }
      case KHOPHIEU_HOMEPAGE_ONE_SUCCESS: {
        return {
          ...state,
          homepageKhophieuSelected: action.data
        }
      }
      case KHOPHIEU_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
        if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageKhophieuLimitFilter !== 'undefined' && state.homepageKhophieuLimitFilter) {
          if (action.data.homepageKhophieuLimitPage == 'no_update' && typeof state.homepageKhophieuLimitFilter.homepageKhophieuLimitPage !== 'undefined') action.data.homepageKhophieuLimitPage = state.homepageKhophieuLimitFilter.homepageKhophieuLimitPage;
          if (action.data.homepageKhophieuLimitLimit == 'no_update' && typeof state.homepageKhophieuLimitFilter.homepageKhophieuLimitLimit !== 'undefined') action.data.homepageKhophieuLimitLimit = state.homepageKhophieuLimitFilter.homepageKhophieuLimitLimit;
        }
        return {
          ...state,
          homepageKhophieuLimitFilter: action.data,
        }
      }
      case KHOPHIEU_LIMIT_HOMEPAGE_LIST_SUCCESS: {
        return {
          ...state,
          homepageKhophieuLimitItems: action.data.homepageKhophieuLimitItems,
          homepageKhophieuLimitTotal: action.data.homepageKhophieuLimitTotal,
        }
      }
      case KHOPHIEU_LIMIT_HOMEPAGE_ONE_SUCCESS: {
        return {
          ...state,
          homepageKhophieuLimitSelected: action.data
        }
      }
      case KHOPHIEU_NEW_CARE_SUCCESS: {
        return {
          ...state,
          newCare: action.data.newCare,
          canCare: action.data.canCare,
        }
      }
      case KHOPHIEU_IMPORT_SUCCESS: {
        return {
          ...state,
          temp: action.data,
        }
      }
      case KHOPHIEU_COUNT_ASSIGN_SUCCESS: {
        return {
          ...state,
          countAssign: action.data,
        }
      }
      case KHOPHIEU_HISTORY_LIST_SUCCESS: {
        return {
          ...state,
          history: action.data.items,
          totalHistory: action.data.total,
        }
      }
      case LOOKUP_CLEANER: {
        return initState
      }
      default: {
        return state;
      }
    }
  }
  export default khophieuReducer